export default __webpack_public_path__ + "static/media/nominapp_icon.893f0852.svg";